<script>
import lazyLoadComponent from '@router/lazyload-component'

import Layout from '@layouts/main'

export default {
  page: {
    title: '訂單查詢',
    meta: [{ name: 'description', container: 'Order List' }],
  },
  components: {
    Layout,
  },
  props: {
    productId: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      activeTab: '0',
      tabList: [
        {
          title: `${this.$t('orderManage.PRICE_ORDER')}`,
          component: () => lazyLoadComponent(import('./TabProduct')),
          types: ['cosmetic'],
        },
        {
          title: `${this.$t('prepaid.BASE')}方案`,
          component: () => lazyLoadComponent(import('./TabPrepaid')),
          types: ['prepaid']
        },
        {
          title: '儲值訂單',
          component: () => lazyLoadComponent(import('./TabDeposit')),
          types: ['deposit']
        },
        {
          title: '住宿訂單',
          component: () => lazyLoadComponent(import('./TabHotel')),
          types: ['hotel']
        },
      ],
    }
  },
  watch: {
    activeTab(newValue) {
      // 使用 $router.push 而不是直接修改 $route.params
      this.$router.push({
        name: this.$route.name,
        params: {
          ...this.$route.params,
          activeTab: newValue
        },
        query: this.$route.query
      })
    },
  },
  created() {
    // 如果沒有儲值訂單選項，就先去掉
    if (!this.$hasDeposit()) {
      const index = this.tabList.findIndex(item => item.types[0] === 'deposit')
      if (index > -1) {
        this.tabList.splice(index, 1)
      }
    }
    // 如果沒有住宿模組權限，就先去掉住宿訂單 tab
    if (!this.$hasHotel()) {
      const index = this.tabList.findIndex(item => item.types[0] === 'hotel')
      if (index > -1) {
        this.tabList.splice(index, 1)
      }
    }
    // 如果有給預設的acrtiveTabName 就先轉到那個activeTabName
    if (this.$route.params.activeTabName) {
      const index = this.tabList.findIndex(item => item.types[0] === this.$route.params.activeTabName)
      if (index > -1) {
        this.activeTab = `${index}`
      }
    }
    if (this.$route.params.activeTab && parseInt(this.activeTab) < this.tabList.length) {
      this.activeTab = this.$route.params.activeTab
    }
    if (this.$route.query.type) {
      if (this.$route.query.type === "order") {
        this.activeTab = "0"
      }
      if (this.$route.query.type === "prepaidOrder") {
        this.activeTab = "1"
      }
      if (this.$route.query.type === "depositOrder") {
        this.activeTab = "2"
      }
      if (this.$route.query.type === "hotelOrder" && this.$hasHotel()) {
        // 找到 hotel tab 的實際索引（因為可能被過濾掉）
        const hotelIndex = this.tabList.findIndex(item => item.types[0] === 'hotel')
        if (hotelIndex > -1) {
          this.activeTab = `${hotelIndex}`
        }
      }
    }
  },
  mounted() {
  },
  provide() {
    return {
      productId: this.productId
    }
  }
}
</script>

<template>
  <Layout>
    <!-- <keep-alive> -->
    <el-tabs v-model="activeTab" type="border-card" stretch class="isStyleBase">
      <el-tab-pane v-for="(tab, index) in tabList" :key="index" :label="tab.title" :name="`${index}`">
      </el-tab-pane>
    </el-tabs>
    <component :is="tabList[activeTab].component" ref="order" :class="$style.pageContent"
      :fetch-types="tabList[activeTab].types">
    </component>

    <!-- </keep-alive> -->
  </Layout>
</template>
<style lang="scss" module>
@import '@src/design/layout_detail_steps.scss';
</style>